import Vue from "vue";

Vue.prototype.$url = {
  transformParams(params) {
    const apiParams =
      "?" +
      Object.keys(params)
        .filter(key => params[key] !== null && params[key] !== undefined)
        .map(key => {
          const value = Array.isArray(params[key])
            ? params[key].join(",")
            : params[key];

          return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
        })
        .join("&");
    return apiParams;
  },
};
